import { Logo } from "@/components/landing/Logo";
import { scrollToId } from "@/lib/scroll";
import { Editable } from "@/components/builder/Editable";
import { useContent } from "@/context/ContentContext";

export const Footer = () => {
  const { ctaClick } = useContent();
  return (
    <footer data-testid="site-footer" className="surface-navy">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
          <div className="max-w-sm">
            <Logo dark />
            <Editable as="p" path="footer.desc" className="mt-3 block text-sm leading-6 text-slate-400">Sedio - l'AI a servizio del condominio, sviluppata da amministratori per amministratori. Comunicazione, segnalazioni e rapporti con fornitori e condomini. Tu decidi sempre.</Editable>
          </div>
          <div className="flex flex-wrap gap-x-8 gap-y-3 text-sm">
            <button onClick={() => scrollToId("come-funziona")} className="text-slate-300 transition-colors duration-200 hover:text-white">Come funziona</button>
            <button onClick={() => scrollToId("funzioni")} className="text-slate-300 transition-colors duration-200 hover:text-white">Funzioni AI</button>
            <button onClick={() => scrollToId("risparmio")} className="text-slate-300 transition-colors duration-200 hover:text-white">Risparmio</button>
            <button data-testid="footer-cta-button" onClick={ctaClick("footer.cta.link", "contatti")} className="font-semibold text-cyan-300 transition-colors duration-200 hover:text-white">Contattaci</button>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-slate-400 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} Nenyre group S.r.l. — P. IVA 05008770231. Tutti i diritti riservati.</p>
          <div className="flex gap-6"><a href="/privacy" className="hover:text-white">Privacy</a><a href="/termini" className="hover:text-white">Termini</a><a href="/#contatti" className="hover:text-white">Contatti</a></div>
        </div>
      </div>
    </footer>
  );
};
